import { Controller } from "@hotwired/stimulus";

// Copies the PIN reveal card's temporary PIN to the clipboard. No server
// round-trip — the PIN is already in the DOM (the whole point of this task
// is to never let it touch anywhere else), so this only ever reads it back.
export default class extends Controller {
  static values = { text: String, copiedLabel: String };
  static targets = ["label"];

  copy() {
    navigator.clipboard
      .writeText(this.textValue)
      .then(() => {
        this.labelTarget.textContent = this.copiedLabelValue;
      })
      .catch(() => {
        // Permission denied or another clipboard failure — leave the label
        // unchanged rather than confirm a copy that didn't happen (the
        // shown-once PIN is the worst possible moment for a false positive).
      });
  }
}
